import React, { FunctionComponent, ReactElement } from 'react';
import ButtonGroupToggle from '../../ButtonGroup/components/ButtonGroupToggle/ButtonGroupToggle';
import ButtonGroupButton from '../../ButtonGroup/components/ButtonGroupButton/ButtonGroupButton';
import Dropdown, { DropdownProps } from '../../Dropdown/Dropdown';
import Tooltip from '../../Tooltip/Tooltip';

interface DefaultMoreDropdownProps extends Omit<DropdownProps, 'trigger'> {
  items: ReactElement[];
  trigger: FunctionComponent;
}

function ConvertedTooltip({ item }) {
  return (
    <Dropdown.Item
      render={() => (
        <Dropdown.Tooltip
          placement="left"
          render={() => {
            return item.props.trigger;
          }}
        >
          {item.props.children}
        </Dropdown.Tooltip>
      )}
    />
  );
}

function ConvertedDropdown({ item }) {
  return (
    <>
      <Dropdown.Header>
        {typeof item.props.trigger === 'function' && item.props.trigger(item.props).props.children}
      </Dropdown.Header>
      {item.props.children}
      <Dropdown.Separator />
    </>
  );
}

function ConvertedDropdownToggle({ item }) {
  return (
    <Dropdown.Item
      render={() =>
        item.props.inputType === 'checkbox' ? (
          <Dropdown.Checkbox
            id={item.props.id}
            type={item.props.inputType}
            label={item.props.label}
            isChecked={item.props.checked}
            {...item.props}
          />
        ) : (
          <Dropdown.Radio
            id={item.props.id}
            type={item.props.inputType}
            label={item.props.label}
            isChecked={item.props.checked}
            {...item.props}
          />
        )
      }
    />
  );
}

function ConvertedDropdownTrigger({ item }) {
  return (
    <Dropdown.Item render={() => <Dropdown.Button id={item.props.id} label={item.props.label} {...item.props} />} />
  );
}

const DefaultMoreDropdown = ({ items, trigger, ...otherProps }: DefaultMoreDropdownProps) => {
  return (
    <Dropdown
      align="right"
      trigger={({ onClick, activeTrigger }) => (
        <Dropdown.Trigger
          onClick={onClick}
          activeTrigger={activeTrigger}
          active={Boolean(items.find(i => i.props.active))}
          component={trigger}
          role="button"
        >
          More
        </Dropdown.Trigger>
      )}
      {...otherProps}
    >
      {items.map((dropdownItem: ReactElement, index) => {
        switch (dropdownItem.type) {
          case Tooltip:
            return <ConvertedTooltip key={index} item={dropdownItem} />;
          case Dropdown:
            return <ConvertedDropdown key={index} item={dropdownItem} />;
          case ButtonGroupButton:
            return <ConvertedDropdownTrigger key={index} item={dropdownItem} />;
          case ButtonGroupToggle:
            return <ConvertedDropdownToggle key={index} item={dropdownItem} />;
          default:
            return <Dropdown.Item active={dropdownItem.props.active} key={index} render={() => dropdownItem} />;
        }
      })}
    </Dropdown>
  );
};

export default DefaultMoreDropdown;
